import React, {PropTypes as T} from 'react';
import Filters from './filters';
import withDevice from '../../common/withDeviceHOC';

export class MAPSideBar extends React.Component {
  static propTypes = {
    isActive: T.bool,
    isMobile: T.bool
  };

  render () {
    let className = 'map__sidebar';
    if (!this.props.isMobile || this.props.isActive) {
      className += ' is-open';
    }
    return (
      <div className={className} data-component="price-category-filters" >
        <Filters {...this.props} />
      </div>
    );
  }
}

export default withDevice(MAPSideBar);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/sidebar/index.js